/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_Select_Material_PlaceholderInputs */

const vi_packaging_bom_select_material_placeholder = /** @type {(inputs: Packaging_Bom_Select_Material_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn vật tư...`)
};

/**

* @param {Packaging_Bom_Select_Material_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_select_material_placeholder = /** @type {((inputs?: Packaging_Bom_Select_Material_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_Select_Material_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_select_material_placeholder(inputs)
});